let language = {
    FORGET_PWD_RESET_TITLE: "Password reset",
    FORGET_PWD_SEND_RESET_LINK_TEXT: "Please input your email address, it would take a few minutes for us to send you the password reset link.",

    FORGET_PWD_FORM_EMAIL_LABEL: "Email:",
    FORGET_PWD_FORM_EMAIL_PLACEHOLDER: "sample@email.com",
    FORGET_PWD_FORM_EMAIL_ERROR_TIP1: "Please enter the correct email address",
    FORGET_PWD_FORM_SEND_BTN: "Send reset email",

    FORGET_PWD_FORM_SIGNIN_TEXT: "Sign in",
    FORGET_PWD_FORM_SIGNUP_TEXT: "Sign up",

    FORGET_PWD_HAS_SEND_TEXT1: "We just sent an email with password reset instructions to",
    FORGET_PWD_HAS_SEND_TEXT2: "Click the link in the email to reset your password. If you don't see the email, check your \'Spam Folder\'.",
    FORGET_PWD_RESEND_TEXT: "I didn't receive the email",
};

export { language }